export default {
  CARD: "card",
};
